import './Login.css'
import { FormEvent, ReactNode, useState } from 'react'
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AxiosError } from 'axios';
import { APIRequestPost } from '../utils/APIRequests';
import { UserRegisterRequestData } from '../api/User';
import { getValidationErrors } from '../api/Auth';
import NewPasswordFields, { PasswordFormErrors, useNewPassword } from './password/NewPasswordFields';

function Register(): ReactNode {
    const { t } = useTranslation(['register', 'base']);

    const [emailValue, setEmailValue] = useState<string>("");
    // Логин — это email, поэтому правило notUsername сверяем с ним.
    const newPassword = useNewPassword(emailValue.trim() || undefined);

    const [errors, setErrors] = useState<string[]>([]);
    const [enabledButton, setEnabledButton] = useState<boolean>(true);

    function submitForm(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault();

        if (!newPassword.isValid) {
            return;
        }

        setEnabledButton(false);
        setErrors([]);

        const data: UserRegisterRequestData = {
            email: emailValue.trim(),
            password: newPassword.password
        };

        APIRequestPost(`/auth/register`, {
            data: data,
            logSuccess: true
        }).then(() => {
            window.location.href = "/confirm-email";
            setEnabledButton(true);
        }).catch((error) => {
            const body = (error as AxiosError).response?.data;

            if (typeof body === 'string' && body) {
                // Прочие отказы сервер отдаёт строкой, например «уже существует»;
                // часть таких строк — ключи переводов, как и раньше.
                setErrors([t(body, { ns: "register" })]);
            } else {
                const validationErrors = getValidationErrors(error);
                setErrors(validationErrors.length > 0 ? validationErrors : [t('error', { ns: "register" })]);
            }
            setEnabledButton(true)
        });
    }

    return (
        <div className='form-page'>
            <div className='form-page-container'>
                <Form onSubmit={submitForm}>
                    <Form.Group className="login-form" controlId="formBasicEmail">
                        <Form.Label>{t('address', { ns: "register" })}</Form.Label>
                        <Form.Control
                            type="email"
                            required
                            autoComplete="email"
                            placeholder={t('address_placeholder', { ns: "register" })}
                            value={emailValue}
                            onChange={e => setEmailValue(e.currentTarget.value)}
                        />
                    </Form.Group>

                    <NewPasswordFields state={newPassword} disabled={!enabledButton} />

                    <Button variant="light" type="submit" disabled={!enabledButton || !newPassword.isValid}>
                        {t('Register', { ns: "base" })}
                    </Button>
                </Form>
                <PasswordFormErrors errors={errors} />
            </div>
        </div>
    )
}

export default Register;
